function normalizeSelectionList(value) {
  if (Array.isArray(value)) return value.map((item) => String(item))
  if (!value) return []

  try {
    const parsedValue = JSON.parse(value)
    return Array.isArray(parsedValue) ? parsedValue.map((item) => String(item)) : [String(value)]
  } catch (_error) {
    return [String(value)]
  }
}

function hasOtherSelection(value) {
  const normalizedValues = normalizeSelectionList(value)
  const otherValues = ['other', 'outro', 'outros', 'outra', 'outras', 'others']

  return normalizedValues.some((item) => otherValues.includes(String(item).toLowerCase()))
}

module.exports = {
  normalizeSelectionList,
  hasOtherSelection
}
